// extracted by mini-css-extract-plugin
module.exports = {"inboxSwitcherItem":"styles_inboxSwitcherItem__1cdQw","inboxName":"styles_inboxName__3zMA8","selected":"styles_selected__3W1Ge"};